/* eslint-disable camelcase */
import React from 'react';

import useHasFeature, { featureNames } from '~/shared/utils/useHasFeature';

import BuilderConstructorGrid from './BuilderConstructorGrid';
import BuilderConstructorGridV1_1 from './BuilderConstructorGridV1_1';

export * from './BuilderConstructorGrid.builder';

const BuilderConstructorGridSwitch = (props) => {
  const isNewConstructorGridEnabled = useHasFeature(
    featureNames.CONSTRUCTOR_GRID_V1_1
  );

  return isNewConstructorGridEnabled ? (
    // eslint-disable-next-line react/jsx-pascal-case
    <BuilderConstructorGridV1_1 {...props} />
  ) : (
    <BuilderConstructorGrid {...props} />
  );
};

export default BuilderConstructorGridSwitch;
